import { Ability } from '@casl/ability';
import Auth from '@/store/modules/auth/constants';
import { buildRules } from '@/helpers/caslHelper';

export const ability = new Ability([], {
  // eslint-disable-next-line no-underscore-dangle
  detectSubjectType: (subject) => (subject && typeof subject === 'string' ? subject : subject.__type),
});

export const abilityPlugin = (store) => {
  if (store.state.auth.userInfo.roles) {
    const { roles, id, clients } = store.state.auth.userInfo;
    ability.update(buildRules(id, roles, clients));
  }

  return store.subscribe((mutation) => {
    if (mutation.payload) {
      const { roles, id, clients } = mutation.payload;

      switch (mutation.type) {
        case `auth/${Auth.mutationTypes.setUserInfo}`:
          if (!roles) {
            ability.update([]);
          } else {
            const rules = buildRules(id, roles, clients);
            ability.update(rules);
          }
          break;

        default:
          break;
      }
    }
  });
};
